import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import MyLabel from "./MyLabel";

const MySelectRHF = ({
  control,
  name,
  title,
  options,
  placeholder,
  errors,
  required,
  isMulti,
  disabled,
}) => {

 
  if (!control) return null;

  return (
    <div className="form-group">
      <MyLabel title={title} name={name} required={required} />

      <Controller
        name={name}
        control={control}
        defaultValue={isMulti ? [] : null}   
        rules={{
          required: required ? `Please select ${title}` : false,
        }}
        render={({ field }) => (
          <Select
            options={options}
            isMulti={isMulti}
            placeholder={placeholder}
            isDisabled={disabled}
            value={field.value}
            onChange={field.onChange}
            styles={{
              control: (base) => ({
                ...base,
                borderColor: errors?.[name] ? "#e85347" : "#dbdfea",
              }),
            }}
          />
        )}
      />

      {errors?.[name] && (
        <span
          style={{
            color: "#e85347",
            fontSize: "11px",
            fontStyle: "italic",
          }}
        >
          {errors[name].message}
        </span>
      )}
    </div>
  );
};

export default MySelectRHF;
